export default __webpack_public_path__ + "static/media/add-row.83a0ccff.svg";